import { render } from "./RecherchePage.vue?vue&type=template&id=b655f57e"
import script from "./RecherchePage.vue?vue&type=script&lang=js"
export * from "./RecherchePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__